import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { BasicsConstance } from './core/models/Enums/basics-constance';
import { RouterOutlet, Router } from '@angular/router';
import { HeaderComponent } from './pages/layout/header/header.component';
import { FooterComponent } from './pages/layout/footer/footer.component';
import { LoaderComponent } from './pages/ui-shared/loader/loader.component';
import { LayoutService } from './core/services/layout/layout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, LoaderComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private _translate = inject(TranslateService);
  router = inject(Router);
  private layoutService = inject(LayoutService);
  
  showHeaderFooter = true;
  
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      // Check if a language is saved in localStorage; if not, set 'ar' as the default
      const savedLang = localStorage.getItem(BasicsConstance.LANG) || 'ar';
      localStorage.setItem(BasicsConstance.LANG, savedLang);

      // Apply the language settings
      this.setLanguage(savedLang);
    }
  }

  ngOnInit(): void {
    // Hide initial loading placeholder for FCP optimization
    if (isPlatformBrowser(this.platformId)) {
      const loading = document.getElementById('initial-loading');
      if (loading) {
        loading.classList.add('hidden');
      }
    }
    
    // Subscribe to layout service to control header/footer visibility
    this.layoutService.showHeaderFooter$.subscribe(show => {
      this.showHeaderFooter = show;
    });
  }

  private setLanguage(lang: string): void {
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
    this._translate.use(lang);
  }
}
